export default {"src":"/_next/static/media/leasebandit_logo_white.4052db18.svg","height":22,"width":306,"blurWidth":0,"blurHeight":0};